import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import PageHeading from "../common/PageHeading";
import Filter from "../common/Filter";
import Table from "../common/Table";
import CheckoutButton from "../invoice/Payment";

export default function DashboardTable({
  accountNumber,
  title,
  columns,
  getData,
  color,
  invoices,
  isFromBottleOrder,
}) {
  const [data, setData] = useState({ loading: false, data: [] });
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  useEffect(() => {
    onSearch();
  }, [page]);

  useEffect(() => {
    onSort();
  }, [sort]);

  useEffect(() => {
    const now = new Date();
    const tenDaysAgo = new Date(now);
    let initialFromDateTime;
    let initialToDateTime;
    if (isFromBottleOrder) {
      tenDaysAgo.setDate(now.getDate() + 365);
      initialFromDateTime = now.toISOString().slice(0, 10);
      initialToDateTime = tenDaysAgo.toISOString().slice(0, 10);
      setFromDate(initialFromDateTime);
      setToDate(initialToDateTime);
    } else {
      tenDaysAgo.setDate(now.getDate() - 365);
      initialFromDateTime = tenDaysAgo.toISOString().slice(0, 10);
      initialToDateTime = now.toISOString().slice(0, 10);
      setFromDate(initialFromDateTime);
      setToDate(initialToDateTime);
    }

    setData({ loading: true, data: [] });
    async function GetData(pg) {
      let sortOrder = "";

      if (sort.length > 0) {
        let so = sort[0].desc === true ? "desc" : "";
        sortOrder = `${sort[0].id}${so}`;
      }

      let data = await getData(
        initialFromDateTime,
        initialToDateTime,
        accountNumber,
        pg,
        filter,
        sortOrder
      );
      setPages(data.pages);
      setData({ loading: false, data: data.data });
    }
    GetData(page);
  }, []);

  const onSearch = () => {
    if (fromDate !== undefined && toDate !== undefined) {
      setData({ loading: true, data: [] });
      async function GetData(pg) {
        let sortOrder = "";

        if (sort.length > 0) {
          let so = sort[0].desc === true ? "desc" : "";
          sortOrder = `${sort[0].id}${so}`;
        }

        let data = await getData(
          fromDate,
          toDate,
          accountNumber,
          pg,
          filter,
          sortOrder
        );
        setPages(data.pages);
        setData({ loading: false, data: data.data });
      }
      GetData(page);
    }
  };

  const onSort = () => {
    if (sort.length > 0) {
      const sortId = sort[0].id;
      const sortDesc = sort[0].desc;
      const sortedData = [...data.data];

      const compareFunction = (a, b) => {
        const aValue = a[sortId];
        const bValue = b[sortId];

        if (aValue < bValue) return sortDesc ? 1 : -1;
        if (aValue > bValue) return sortDesc ? -1 : 1;
        return 0;
      };

      sortedData.sort(compareFunction);
      setData({ ...data, data: sortedData });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <PageHeading
        title={title}
        action={title === "Invoices" && <CheckoutButton invoices={invoices} />}
      />

      <Paper sx={{ p: 2, mb: 2 }}>
              {/* A form so Enter submits from any field in the row, including the
                  date inputs, not just the search box. */}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  onSearch();
                }}
              >
              {/* Control order is shared with Lab Orders: search, then dates, then
                  the button. Search is md 5 against md 2.5 dates, i.e. double width. */}
              <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
                <Grid size={{ xs: 12, sm: 12, md: 5 }}>
                  <Filter
                    searchFunction={setFilter}
                    loading={data.loading}
                    color={color}
                    onSubmit={onSearch}
                  />
                </Grid>

                <Grid size={{ xs: 6, sm: 4, md: 2.5 }}>
                  <TextField
                    id="fromDate"
                    label="From Date"
                    type="date"
                    fullWidth
                    size="small"
                    value={fromDate || ""}
                    onChange={(e) => setFromDate(e.target.value)}
                    disabled={data.loading}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid size={{ xs: 6, sm: 4, md: 2.5 }}>
                  <TextField
                    id="toDate"
                    label="To Date"
                    type="date"
                    fullWidth
                    size="small"
                    value={toDate || ""}
                    onChange={(e) => setToDate(e.target.value)}
                    disabled={data.loading}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 2 }}>
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    disableElevation
                    disabled={data.loading}
                    sx={{ height: "40px" }}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
              </form>
      </Paper>

      <Table
                columns={columns}
                data={data.data}
                color={color}
                setPage={setPage}
                totalPage={pages}
                currentpage={page}
                loading={data.loading}
                setSortBy={setSort}
              />
    </Box>
  );
}
